define('mailsMailHeaderLabelsAddDatalistOptionView',[
  'module',
  'marionette',
  'underscore',
  'template!mailsMailHeaderLabelsAddDatalistOptionView'
], function (
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,       
    tagName: 'option',

    attributes: function() {
      return {
        value: this.model.get('fullName')
      };
    },

    serializeData: function() {
      var data = {};
      data.name = this.model.get('fullName');
      return data;
    }
  });
});
  
